import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { listCases } from "../api"
import type { CaseFileListRow } from "../contract"
import { lakh, shortDate } from "../answer/format"
import { matterPath } from "../answer/NiraHistory"
import { daysTo } from "../case/Matters"

/**
 * The signed-in Home's first block (handoff 3 §12, Home-SignedIn): every reply due in the next seven
 * days across the case files, soonest first, each with its matter, its amount and one action.
 * Nothing renders for a reader with no case files.
 */
export function DueThisWeek({ now = new Date() }: { now?: Date }) {
  const [rows, setRows] = useState<CaseFileListRow[] | null>(null)
  useEffect(() => {
    let live = true
    listCases()
      .then((r) => live && setRows(Array.isArray(r) ? r : []))
      .catch(() => live && setRows([]))
    return () => {
      live = false
    }
  }, [])
  if (!rows?.length) return null
  const due = rows
    .map((m) => ({ m, left: m.facts?.reply_due ? daysTo(m.facts.reply_due, now) : null }))
    .filter((x): x is { m: CaseFileListRow; left: number } => x.left !== null && x.left >= 0 && x.left <= 7)
    .sort((a, b) => a.left - b.left)
  return (
    <section className="nh-due" aria-labelledby="nh-due-h">
      <h2 id="nh-due-h" className="nh-eyebrow">Due this week</h2>
      {due.length ? (
        <ul>
          {due.map(({ m, left }) => (
            <li key={m.id}>
              <span className="nh-due-d">
                <b>{shortDate(m.facts.reply_due)}</b>
                <span>{left === 0 ? "today" : left === 1 ? "tomorrow" : `${left} days`}</span>
              </span>
              <span className="nh-due-t">
                <span className="nh-due-m">{m.title}</span>
                <span className="nh-due-f">{["Reply", m.facts.proposed_total ? lakh(m.facts.proposed_total) : "", m.facts.section ? `s.${m.facts.section}` : ""].filter(Boolean).join(" · ")}</span>
              </span>
              <Link className="nh-due-act" to={matterPath(m)}>Open</Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className="nh-due-none">
          Nothing due this week · <Link to="/workspaces">{rows.length} {rows.length === 1 ? "workspace" : "workspaces"}</Link>
        </p>
      )}
    </section>
  )
}
